import './quotePolicyList.scss';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { convertProductIdToName, convertProductIdToWebReference } from '../../functions/ProductIds';
import { IsWebReferenceSuffix } from '../../functions/Configuration';
import { GetLogo } from '../../components/quote/Logos';

export default function QuotePolicyList(props: any) {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const navigate = useNavigate();

    const GetTimeLeftOnCover = (startDateString: any) => {
        let dateParts = startDateString.split("/");
        let expiryDate = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        expiryDate.setFullYear(expiryDate.getFullYear() + 1);
        let today = new Date();
        //let timeLeftOnCover = Math.round(Math.abs((+expiryDate) - (+today)) / 8.64e7);
        let timeDifference = expiryDate.getTime() - today.getTime();
        let timeLeftOnCover = Math.round(timeDifference / (1000 * 3600 * 24));


        if (today >= expiryDate) {
            return "(Expired)"
        } else {
            let timeLeftOnCoverMessage = "";
            if (timeLeftOnCover > 60)
                timeLeftOnCoverMessage = "(Expires in " + Math.round(timeLeftOnCover / 30) + " months)";
            if (timeLeftOnCover > 1 && timeLeftOnCover < 60)
                timeLeftOnCoverMessage = "(Expires in " + timeLeftOnCover + " days)";
            if (timeLeftOnCover === 1)
                timeLeftOnCoverMessage = "(Expires in " + timeLeftOnCover + " day)";
            if (timeLeftOnCover === 0)
                timeLeftOnCoverMessage = "(Expires today)";

            return timeLeftOnCoverMessage;
        }

    }

    const GetTimeLeftOnCoverClassName = (startDateString: any) => {
        let dateParts = startDateString.split("/");
        let expiryDate = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        expiryDate.setFullYear(expiryDate.getFullYear() + 1);
        let today = new Date();
        let timeDifference = expiryDate.getTime() - today.getTime();
        let timeLeftOnCover = Math.round(timeDifference / (1000 * 3600 * 24));

        let className = "expires-lbl";

        if (today >= expiryDate) {
            className = className + " expired";
        } else {
            if (timeLeftOnCover >= 0 && timeLeftOnCover < 60)
                className = className + " expiring";
        }
        return className;
    }

    const getStartDateDisplay = (startDateString: any) => {
        if (props.title === "Incomplete Quotes" && startDateString === "30/12/1899") {
            return "Not Set";
        } else {
            return startDateString;
        }
    }

    const buyQuote = (quote: any) => {
        const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData') as string) : null;
        window.location.href = `${window.location.origin}/Loading?policyDetailsID=${quote.policyDetailsID}&policyDetailsHID=1&productID=${quote.productID}&productType=${quote.productType}&agentID=${quote.agentID}&email=${userData.email}&policyNumber=${quote.policyNumber}&webReference=${convertProductIdToWebReference(quote.productType)}`;
    }

    const renewPolicy = (policy: any) => {
        window.location.href = `${window.location.origin}/Loading?renewalPolicyNumber=${policy.policyNumber}&renewalPolicyHID=${policy.historyID}`;
    }

    const amendQuote = (quote: any) => {
        const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData') as string) : null;
        if (quote.policyStatusID === "Policy" || quote.policyStatusDebug === "Renewal Pending") {
            localStorage.setItem("policyNumberMTA", quote.policyNumber);
            navigate("/MTA");
        } else {
            if (quote.policyStatusID === "Incomplete") {
                window.location.href = `${window.location.origin}/Loading?policyDetailsID=${quote.policyDetailsID}&policyDetailsHID=1&productID=${quote.productID}&productType=${quote.productType}&agentID=${quote.agentID}&email=${userData.email}&policyNumber=${quote.policyNumber}&webReference=${convertProductIdToWebReference(quote.productType)}&action=amend&incomplete=true`;
            } else {
                window.location.href = `${window.location.origin}/Loading?policyDetailsID=${quote.policyDetailsID}&policyDetailsHID=1&productID=${quote.productID}&productType=${quote.productType}&agentID=${quote.agentID}&email=${userData.email}&policyNumber=${quote.policyNumber}&webReference=${convertProductIdToWebReference(quote.productType)}&action=amend`;
            }
        }
    }

    return (
        <>
            <div className="quote-policy-list-container">
                <h1 className={props.title.toLowerCase().replaceAll(" ", "-")}
                    onClick={() => props.openedAccordionChanged(props.title)}>{props.title}
                    {props.title !== props.openedAccordion &&
                        <span className="quote-policy-list-chevron"><FontAwesomeIcon onClick={() => props.openedAccordionChanged(props.title)} icon={faChevronDown} /></span>
                    }
                    {props.title === props.openedAccordion &&
                        <span className="quote-policy-list-chevron"><FontAwesomeIcon onClick={() => props.openedAccordionChanged(props.title)} icon={faChevronUp} /></span>
                    }
                </h1>
                {props.itemList.length > 0 && props.title === props.openedAccordion &&
                    <div className="quote-policy-list-tbl-conatiner">
                        <table className="quote-policy-list-tbl">
                            <thead>
                                <tr>
                                    <th>Cover Start</th>
                                    <th>Insurance Type</th>
                                    {props.title !== "Incomplete Quotes" &&
                                        <th>Insurer</th>
                                    }
                                    <th>Annual Premium</th>
                                    <th>Reference</th>
                                    {props.title === "Incomplete Quotes" &&
                                        <th>Status</th>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {props.itemList.map((item: any, index: number) => {
                                    return (
                                        <tr key={item.policyNumber + item.historyID}>
                                            <td data-label="Cover Start">{getStartDateDisplay(item.startDate)}
                                                {props.title === "Purchased Policies" &&
                                                    <span className={GetTimeLeftOnCoverClassName(item.startDate)}><br /> {GetTimeLeftOnCover(item.startDate)}</span>
                                                }
                                            </td>
                                            <td data-label="Insurance Type">{convertProductIdToName(item.productType)}</td>
                                            {props.title !== "Incomplete Quotes" &&
                                                <td data-label="Insurer">
                                                    {GetLogo(item.schemeName, item.insurerID, item.insurer, true)}
                                                </td>
                                            }
                                            <td data-label="Annual Premium">&pound;{Number(item.premium).toFixed(2)}</td>
                                            <td data-label="Reference">{item.policyNumber}</td>
                                            {props.title === "Incomplete Quotes" &&
                                                <td data-label="Status">{item.policyStatusID}</td>
                                            }
                                            <td className="button-container">
                                                {props.title === "Ready to Renew" &&
                                                    <button onClick={() => renewPolicy(item)} className="btn">Renew</button>
                                                }
                                                {props.title === "Current Quotes" &&
                                                    <button onClick={() => buyQuote(item)} className="btn">Buy</button>
                                                }
                                                {props.title === "Purchased Policies" &&
                                                    <button onClick={() => navigate("/YourDocuments", {
                                                        state: {
                                                            policyNumber: item.policyNumber,
                                                            insurer: item.insurer,
                                                            productType: item.productType
                                                        }
                                                    })} className="btn">Documents</button>

                                                }
                                                {props.title !== "Ready to Renew" && (!IsWebReferenceSuffix(convertProductIdToWebReference(item.productType), "PO") || item.policyStatusID === "Incomplete" || item.policyStatusID === "Policy") &&
                                                    <button onClick={() => amendQuote(item)} className="btn">Amend</button>
                                                }
                                            </td>
                                        </tr>
                                    )
                                }
                                )}
                            </tbody>
                        </table>
                    </div>
                }

                {props.itemList.length === 0 && props.title === props.openedAccordion &&
                    <p>{props.noneMessage}</p>
                }
            </div>
        </>
    );
}
